<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20.001" height="20.001" viewBox="0 0 20.001 20.001"><path class="bullhorn-a" d="M-1868-6825a10.011,10.011,0,0,1-10-10,10.012,10.012,0,0,1,10-10,10.013,10.013,0,0,1,10,10A10.012,10.012,0,0,1-1868-6825Zm2.951-15.009-3.592,2.313h-2.872a1.494,1.494,0,0,0-1.438,1.541v1.541a1.494,1.494,0,0,0,1.438,1.541h.718v2.313a.746.746,0,0,0,.718.77.746.746,0,0,0,.718-.77v-2.312h.718l3.592,2.313Zm1,1.4h0v6.691a4.451,4.451,0,0,0,1.5-3.34A4.5,4.5,0,0,0-1864.047-6838.612Z" transform="translate(1878 6845)"/></svg>
</template>

<script>
	export default {
		name: 'bullhorn'
	}
</script>

<style>
	.bullhorn-a {
		fill: #fff;
	}
</style>